<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="$t('page.registration_time_slot_new.title')"
            back
        />
        <v-row>
            <v-col cols="12">
                <RegistrationTimeSlotForm
                    :data="data"
                    :raw-data="rawData"
                    :errors="formErrors"
                    :save-function="saveObject"
                    :discard-function="resetObject"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import PageHeader from '@/components/common/PageHeader';
import RegistrationTimeSlotForm from '@/components/registrationTimeSlot/Form/RegistrationTimeSlotForm';
import RegistrationTimeSlotProxy from '@/proxies/RegistrationTimeSlotProxy';
import RegistrationTimeSlotMixin from '@/mixins/registrationTimeSlot';
import DatesMixin from '@/mixins/dates';
import { StandBy, SuccessSnackbar } from '@/app-events.js';

export default {
    name: 'RegistrationTimeSlotNew',
    mixins: [
        RegistrationTimeSlotMixin,
        DatesMixin,
    ],
    components: {
        PageHeader,
        RegistrationTimeSlotForm,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.registration_time_slot.title'),
                    exact: true,
                    to: { name: 'registration_time_slot' },
                },
                {
                    text: this.$t('general.new'),
                    disabled: true,
                },
            ],
            data: {
                default: false,
                selectDate: true,
            },
            rawData: {
                default: false,
                selectDate: true,
            },
        };
    },
    created() {
        if (typeof this.$route.params.date !== 'undefined') {
            const dateParts = this.$route.params.date.split('.');
            const week = new Date(dateParts[ 1 ]);
            const date = new Date(week.getTime());
            date.setDate(week.getDate() + (dateParts[ 2 ]-1));

            this.data = {
                default: dateParts[ 0 ] == '1' ? true : false,
                selectDate: false,
                startDay: this.formatDateISO(date),
            };
            this.rawData = {
                default: dateParts[ 0 ] == '1' ? true : false,
                selectDate: false,
                startDay: this.formatDateISO(date),
            };
        }
        this.data.id = null;
        this.rawData.id = null;
    },
    methods: {
        saveObject() {
            if (JSON.stringify(this.data) === JSON.stringify(this.rawData)) {
                return;
            }
            this.$eventBus.dispatch(new StandBy(true));
            new RegistrationTimeSlotProxy().new(this.prepareFormData(this.data)).then(({ data }) => {
                this.$eventBus.dispatch(new StandBy(false));
                this.$eventBus.dispatch(new SuccessSnackbar(this.$t('registration_time_slot.actions.created')));
                this.$router.push({ name: 'registration_time_slot_detail', params: { id: data.data.id } });
            }).catch(({ data }) => {
                this.processErrors(data);
                this.$eventBus.dispatch(new StandBy(false));
            });
        }
    },
};
</script>
